import { mapRejectReasonOptions } from '@shared/constants/proposalRejectReasons.js';

export function getRejectReasonModalProps($t) {
  return {
    showReasonInput: true,
    reasonRequired: true,
    reasonLabel: $t('proposals.reject_reason_label'),
    reasonPlaceholder: $t('proposals.reject_reason_note_placeholder'),
    reasonNoteLabel: $t('proposals.reject_reason_note_label'),
    reasonRequiredMessage: $t('proposals.reject_reason_required'),
    reasonPresets: mapRejectReasonOptions((code) => $t(`proposals.reject_reasons.${code}`)),
  };
}
